/**
 * ĐƠN TỪ VÀ PHIẾU ĐỀ XUẤT (05/10/2026, chủ dự án: «Những nhân viên đi làm muộn xin phép trưởng phòng, trưởng
 * phòng xác nhận, mới có hiệu lực» · «Thiết kế đơn xin nghỉ phép … nghỉ ngày, buổi liên kết với chấm công» ·
 * «Thiết kế các mẫu đề xuất, tuyển dụng, được duyệt theo thứ tự các cấp quản lý» · rồi, kèm ảnh mẫu «Phiếu đề
 * xuất»: «từng mẫu đơn cụ thể, xem in duyệt … như hình»).
 *
 * Một bộ máy duyệt chung. Luật dùng chung cho máy chủ (chặn thật) và web (hiện nút):
 *  • Xin đi muộn, nghỉ phép: người đứng đầu PHÒNG duyệt (Trưởng phòng / Phó phòng — cờ `leadsDepartment`),
 *    trên cấp người xin; phòng không có ai như thế thì Giám đốc.
 *  • Bảy loại phiếu đề xuất (theo ảnh mẫu): tuyển dụng · mua hàng · nạp tiền tài khoản · tạm ứng · đề nghị
 *    thanh toán · công tác phí · lịch công tác. Đi qua Trưởng nhóm → trưởng phòng → HÀNH CHÍNH (tuyển dụng)
 *    hoặc KẾ TOÁN (nạp tiền, tạm ứng, thanh toán, công tác phí) → Giám đốc; cấp nào không có thì bỏ qua.
 *  • Giám đốc duyệt được ở bất kỳ bước nào và là lời cuối; phiếu do Giám đốc lập có hiệu lực ngay.
 *  • Duyệt xong, hành chính / kế toán THỰC HIỆN (mua, chi tiền, tuyển…) rồi đánh dấu «đã thực hiện».
 *  • Một bước «không duyệt» là cả phiếu không được duyệt. Chỉ đơn ĐÃ DUYỆT mới có hiệu lực với chấm công.
 */
import { outranks, roleHasFlag } from './roles.js';
export const REQUEST_KINDS = [
    'late',
    'leave',
    'recruitment',
    'purchase',
    'topup',
    'advance',
    'payment',
    'trip-expense',
    'trip',
];
/** Bảy loại phiếu đề xuất, theo thứ tự trong menu «Lập phiếu» của ảnh mẫu. */
export const PROPOSAL_KINDS = [
    'recruitment',
    'purchase',
    'topup',
    'advance',
    'payment',
    'trip-expense',
    'trip',
];
export const REQUEST_KIND_LABELS = {
    late: 'Xin đi muộn',
    leave: 'Nghỉ phép',
    recruitment: 'Đề xuất tuyển dụng',
    purchase: 'Đề nghị mua hàng',
    topup: 'Đề xuất nạp tiền tài khoản',
    advance: 'Đề xuất tạm ứng',
    payment: 'Đề nghị thanh toán',
    'trip-expense': 'Công tác phí',
    trip: 'Lịch công tác',
};
/** Nhãn ngắn dưới số phiếu («Mua hàng», «Tạm ứng»). */
export const REQUEST_KIND_SHORT = {
    late: 'Đi muộn',
    leave: 'Nghỉ phép',
    recruitment: 'Tuyển dụng',
    purchase: 'Mua hàng',
    topup: 'Nạp tiền',
    advance: 'Tạm ứng',
    payment: 'Thanh toán',
    'trip-expense': 'Công tác phí',
    trip: 'Lịch công tác',
};
/** Một dòng mô tả dưới tên mẫu trong menu «Lập phiếu». */
export const REQUEST_KIND_HINTS = {
    late: 'Xin phép đi muộn một ngày, trưởng phòng xác nhận',
    leave: 'Nghỉ cả ngày hoặc một buổi, nối với bảng chấm công',
    recruitment: 'Xin bổ sung nhân sự cho nhóm / phòng',
    purchase: 'Mua tài nguyên, thiết bị, công cụ',
    topup: 'Nạp tiền tài khoản Like, AI, quảng cáo…',
    advance: 'Xin tạm ứng một khoản, hẹn ngày hoàn ứng',
    payment: 'Xin thanh toán cho cá nhân hoặc nhà cung cấp',
    'trip-expense': 'Dự trù tạm ứng hoặc quyết toán chi phí chuyến công tác',
    trip: 'Đăng ký lịch đi công tác: ai đi, đi đâu, bao giờ',
};
/** Đầu số phiếu: «MTN-2026-007». */
export const REQUEST_CODE_PREFIX = {
    late: 'DM',
    leave: 'NP',
    recruitment: 'TD',
    purchase: 'MTN',
    topup: 'NT',
    advance: 'TU',
    payment: 'TT',
    'trip-expense': 'CTP',
    trip: 'LCT',
};
export const isRequestKind = (value) => REQUEST_KINDS.includes(value);
/** `done` = đã duyệt VÀ hành chính / kế toán đã thực hiện. */
export const REQUEST_STATUSES = ['pending', 'approved', 'done', 'rejected', 'cancelled'];
export const REQUEST_STATUS_LABELS = {
    pending: 'Chờ duyệt',
    approved: 'Đã duyệt',
    done: 'Đã thực hiện',
    rejected: 'Không duyệt',
    cancelled: 'Đã huỷ',
};
export const isRequestStatus = (value) => REQUEST_STATUSES.includes(value);
/**
 * Cấp duyệt của một bước. `unitId` là mã nhóm / phòng (bước hành chính, kế toán: mã phòng làm việc ấy); bước
 * Giám đốc thì rỗng.
 */
export const APPROVAL_LEVELS = ['team', 'department', 'admin', 'accounting', 'director'];
export const APPROVAL_LEVEL_LABELS = {
    team: 'Trưởng nhóm',
    department: 'Trưởng phòng',
    admin: 'Hành chính',
    accounting: 'Kế toán',
    director: 'Giám đốc',
};
/** Phiếu nào qua bước hành chính / kế toán (theo ảnh mẫu); loại khác thì không. */
export const REQUEST_FUNCTIONAL_STEP = {
    recruitment: 'admin',
    topup: 'accounting',
    advance: 'accounting',
    payment: 'accounting',
    'trip-expense': 'accounting',
};
/**
 * Ai THỰC HIỆN phiếu đã duyệt và nút họ bấm («Đã mua xong», «Đã chi tạm ứng»…). Loại không có ở đây (xin đi
 * muộn, nghỉ phép, lịch công tác) thì duyệt xong là xong.
 */
export const REQUEST_EXECUTION = {
    recruitment: { unit: 'admin', action: 'Đã tuyển xong' },
    purchase: { unit: 'admin', action: 'Đã mua xong' },
    topup: { unit: 'accounting', action: 'Đã nạp tiền' },
    advance: { unit: 'accounting', action: 'Đã chi tạm ứng' },
    payment: { unit: 'accounting', action: 'Đã thanh toán' },
    'trip-expense': { unit: 'accounting', action: 'Đã chi công tác phí' },
};
// ------------------------------------------------------------------ cài đặt
export const REQUEST_SETTING_KEY = 'donTu';
/**
 * Tên, địa chỉ, người đứng đầu in trên phiếu — theo thông tin DỰ ÁN SUN MUSIC (chủ dự án 06/10/2026: «Thay
 * đổi toàn bộ thông tin web sang thông tin này»). Trước đó là mẫu giấy CÔNG TY TNHH THANH GIẢN (05/10/2026).
 */
export const DEFAULT_REQUEST_SETTINGS = {
    adminDepartment: '',
    accountingDepartment: '',
    companyName: 'DỰ ÁN SUN MUSIC',
    companyAddress: 'Cantavil Building, 600A Điện Biên Phủ, Ward 22, Bình Thạnh District, Ho Chi Minh City',
    headTitle: 'Trưởng dự án',
    headName: 'Nguyễn Cảnh Toàn',
};
const textOf = (value, max) => typeof value === 'string' ? value.trim().slice(0, max) : '';
/** Đọc khoá `donTu`; thiếu / hỏng thì mặc định. Địa chỉ cố ý để trống thì giữ trống. */
export function readRequestSettings(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return { ...DEFAULT_REQUEST_SETTINGS };
    }
    const raw = value;
    return {
        adminDepartment: textOf(raw.adminDepartment, 64),
        accountingDepartment: textOf(raw.accountingDepartment, 64),
        companyName: textOf(raw.companyName, 120) || DEFAULT_REQUEST_SETTINGS.companyName,
        companyAddress: typeof raw.companyAddress === 'string'
            ? textOf(raw.companyAddress, 200)
            : DEFAULT_REQUEST_SETTINGS.companyAddress,
        headTitle: textOf(raw.headTitle, 60) || DEFAULT_REQUEST_SETTINGS.headTitle,
        headName: typeof raw.headName === 'string'
            ? textOf(raw.headName, 120)
            : DEFAULT_REQUEST_SETTINGS.headName,
    };
}
/**
 * Phòng hành chính / kế toán đang dùng: theo Cài đặt; chưa đặt thì đoán theo tên phòng («Phòng HCKT»,
 * «Hành chính», «Kế toán») để chạy được ngay. Không đoán ra thì '' — bước ấy được bỏ qua.
 */
export function functionalDepartments(settings, departments) {
    const exists = (id) => departments.some((unit) => unit.id === id);
    const guess = (pattern) => departments.find((unit) => pattern.test(unit.name.normalize('NFC')))?.id ?? '';
    return {
        admin: exists(settings.adminDepartment)
            ? settings.adminDepartment
            : guess(/hành\s*chính|hckt|\bhc\b/i),
        accounting: exists(settings.accountingDepartment)
            ? settings.accountingDepartment
            : guess(/kế\s*toán|hckt|\bkt\b/i),
    };
}
const leadsDepartmentOf = (person, departmentId) => !!departmentId &&
    roleHasFlag(person.role, 'leadsDepartment') &&
    (person.departmentId === departmentId || person.extraDepartmentIds.includes(departmentId));
const leadsTeamOf = (person, teamId) => !!teamId && person.role === 'TEAM_LEAD' && person.teamId === teamId;
/** Người này làm việc ở phòng `departmentId` (phòng chính hoặc phòng kiêm nhiệm). */
export const worksIn = (person, departmentId) => !!departmentId &&
    (person.departmentId === departmentId || person.extraDepartmentIds.includes(departmentId));
/**
 * Chuỗi duyệt của một phiếu mới, theo người lập, những người đang làm việc (`staff`) và phòng hành chính /
 * kế toán (`functional`). Rỗng = không cần ai duyệt (phiếu của Giám đốc): có hiệu lực ngay khi gửi.
 */
export function planApprovalChain(kind, requester, staff, functional = { admin: '', accounting: '' }) {
    if (requester.role === 'DIRECTOR')
        return [];
    const others = staff.filter((person) => person.username !== requester.username);
    const above = (person) => outranks(person.role, requester.role);
    const hasTeamLead = others.some((person) => above(person) && leadsTeamOf(person, requester.teamId));
    const hasDepartmentLead = others.some((person) => above(person) && leadsDepartmentOf(person, requester.departmentId));
    if (kind === 'late' || kind === 'leave') {
        return hasDepartmentLead
            ? [{ level: 'department', unitId: requester.departmentId }]
            : [{ level: 'director', unitId: '' }];
    }
    const steps = [];
    if (hasTeamLead)
        steps.push({ level: 'team', unitId: requester.teamId });
    if (hasDepartmentLead)
        steps.push({ level: 'department', unitId: requester.departmentId });
    const unit = REQUEST_FUNCTIONAL_STEP[kind];
    const unitId = unit ? functional[unit] : '';
    // Bước hành chính / kế toán: phòng ấy phải có người đứng đầu (không phải chính người lập), và không phải
    // phòng của người lập — trưởng phòng ấy đã duyệt ở bước trưởng phòng rồi.
    if (unit &&
        unitId &&
        unitId !== requester.departmentId &&
        others.some((person) => leadsDepartmentOf(person, unitId))) {
        steps.push({ level: unit, unitId });
    }
    steps.push({ level: 'director', unitId: '' });
    return steps;
}
/**
 * `decider` duyệt được bước này của phiếu do `requester` lập không. Không ai tự duyệt phiếu của mình; Giám
 * đốc duyệt được mọi bước; Trưởng nhóm / trưởng phòng phải đúng nhóm / phòng VÀ trên cấp người lập; bước
 * hành chính / kế toán là việc chuyên môn: người đứng đầu phòng ấy duyệt, không xét cấp.
 */
export function canDecideStep(decider, step, requester) {
    if (decider.username === requester.username)
        return false;
    if (decider.role === 'DIRECTOR')
        return true;
    if (step.level === 'admin' || step.level === 'accounting') {
        return leadsDepartmentOf(decider, step.unitId);
    }
    if (!outranks(decider.role, requester.role))
        return false;
    if (step.level === 'team')
        return leadsTeamOf(decider, step.unitId);
    if (step.level === 'department')
        return leadsDepartmentOf(decider, step.unitId);
    return false;
}
/** Người này THỰC HIỆN được phiếu loại `kind` đã duyệt không: Giám đốc, hoặc người của phòng thực hiện. */
export function canExecuteRequest(person, kind, functional) {
    const execution = REQUEST_EXECUTION[kind];
    if (!execution)
        return false;
    if (person.role === 'DIRECTOR')
        return true;
    return worksIn(person, functional[execution.unit]);
}
/** «Trưởng nhóm · Nhóm OPM» — nhãn một bước cho người xem, `unitName` tra tên nhóm / phòng. */
export function approvalStepLabel(step, unitName) {
    const level = APPROVAL_LEVEL_LABELS[step.level];
    return step.unitId ? `${level} · ${unitName(step.unitId)}` : level;
}
// ------------------------------------------------------------------ nghỉ phép
export const LEAVE_TYPES = ['annual', 'sick', 'personal', 'unpaid'];
export const LEAVE_TYPE_LABELS = {
    annual: 'Nghỉ phép năm',
    sick: 'Nghỉ ốm',
    personal: 'Nghỉ việc riêng',
    unpaid: 'Nghỉ không lương',
};
/** Nghỉ cả ngày, hay một buổi. Buổi sáng là các mốc chấm công trước 12:00, buổi chiều từ 12:00. */
export const LEAVE_SESSIONS = ['full', 'morning', 'afternoon'];
export const LEAVE_SESSION_LABELS = {
    full: 'Cả ngày',
    morning: 'Buổi sáng',
    afternoon: 'Buổi chiều',
};
/** Ranh giới hai buổi, phút trong ngày. */
export const NOON_MINUTES = 12 * 60;
/** Mốc ở giờ `minutes` có nằm trong buổi được nghỉ không. */
export function minutesInSession(minutes, session) {
    if (session === 'full')
        return true;
    return session === 'morning' ? minutes < NOON_MINUTES : minutes >= NOON_MINUTES;
}
// ------------------------------------------------------------------ các mẫu phiếu
export const RECRUITMENT_REASONS = ['replace', 'expand', 'new-role'];
export const RECRUITMENT_REASON_LABELS = {
    replace: 'Thay người nghỉ việc',
    expand: 'Mở rộng đội ngũ',
    'new-role': 'Vị trí mới',
};
export const TOPUP_ACCOUNTS = ['like', 'ai', 'ads', 'other'];
export const TOPUP_ACCOUNT_LABELS = {
    like: 'Tài khoản Like',
    ai: 'Tài khoản AI',
    ads: 'Tài khoản quảng cáo',
    other: 'Khác',
};
export const PAY_METHODS = ['cash', 'transfer'];
export const PAY_METHOD_LABELS = {
    cash: 'Tiền mặt',
    transfer: 'Chuyển khoản',
};
export const PAYEE_KINDS = ['person', 'supplier'];
export const PAYEE_KIND_LABELS = {
    person: 'Cá nhân',
    supplier: 'Nhà cung cấp',
};
/** «Giấy tờ kèm theo» của đề nghị thanh toán (ô tích trên mẫu giấy). */
export const PAYMENT_DOCUMENTS = ['order', 'contract', 'invoice', 'other'];
export const PAYMENT_DOCUMENT_LABELS = {
    order: 'Đơn đặt hàng',
    contract: 'Hợp đồng',
    invoice: 'Hóa đơn',
    other: 'Khác',
};
/** Công tác phí: «LOẠI: TẠM ỨNG / THANH TOÁN» như mẫu giấy — xin tạm ứng trước chuyến hay thanh toán sau. */
export const TRIP_EXPENSE_MODES = ['estimate', 'settle'];
export const TRIP_EXPENSE_MODE_LABELS = {
    estimate: 'Tạm ứng',
    settle: 'Thanh toán',
};
/**
 * Các khoản «A. CHI PHÍ» của mẫu công tác phí, đúng thứ tự trên giấy. «4. Chi phí giao tế» không nằm ở đây:
 * nó là tổng bảng «Diễn giải chi tiết khoản giao tế» (`guests`).
 */
export const TRIP_COST_ITEMS = ['room', 'ticket', 'taxi', 'local', 'living', 'other'];
export const TRIP_COST_LABELS = {
    room: 'Tiền phòng',
    ticket: 'Vé máy bay, vé tàu xe',
    taxi: 'Taxi',
    local: 'PC đi lại địa phương',
    living: 'Sinh hoạt phí',
    other: 'Chi phí khác',
};
export const TRIP_TRANSPORTS = ['plane', 'train', 'coach', 'car', 'motorbike', 'other'];
export const TRIP_TRANSPORT_LABELS = {
    plane: 'Máy bay',
    train: 'Tàu hoả',
    coach: 'Xe khách',
    car: 'Ô tô',
    motorbike: 'Xe máy',
    other: 'Khác',
};
export const REQUEST_LIMITS = {
    title: 160,
    reason: 500,
    content: 3000,
    comment: 500,
    /** Một đơn nghỉ phép dài nhất (ngày lịch). */
    leaveSpan: 31,
    recruitQuantity: 50,
    /** Số dòng mặt hàng / khoản thanh toán trên một phiếu. */
    lines: 30,
    /** Số đối tác trong bảng chi tiết khoản giao tế (công tác phí). */
    guests: 20,
    /** Số người đi trên một lịch công tác. */
    travellers: 30,
    /** Số tiền lớn nhất một phiếu (đồng). */
    amount: 100_000_000_000,
};
const finite = (value) => typeof value === 'number' && Number.isFinite(value) ? value : 0;
const objectsOf = (value) => Array.isArray(value)
    ? value.filter((item) => !!item && typeof item === 'object')
    : [];
/** Tổng tiền các dòng mặt hàng (số lượng × đơn giá) — đề nghị mua hàng. */
export function linesTotal(lines) {
    return objectsOf(lines).reduce((sum, line) => sum + finite(line.quantity) * finite(line.price), 0);
}
/** Tổng các khoản của đề nghị thanh toán (mỗi dòng một số tiền). */
export function paymentLinesTotal(lines) {
    return objectsOf(lines).reduce((sum, line) => sum + finite(line.amount), 0);
}
/** Thành tiền một khoản «A. CHI PHÍ» của công tác phí (số lượng × đơn giá). */
export function tripCostAmount(costs, item) {
    const raw = costs && typeof costs === 'object' ? costs[item] : null;
    if (!raw || typeof raw !== 'object')
        return 0;
    const cost = raw;
    return finite(cost.quantity) * finite(cost.price);
}
/** «4. Chi phí giao tế» = tổng bảng chi tiết khoản giao tế (số tiền + VAT từng đối tác). */
export function tripGuestsTotal(guests) {
    return objectsOf(guests).reduce((sum, guest) => sum + finite(guest.amount) + finite(guest.vat), 0);
}
/** «Tổng cộng» phần A của công tác phí: các khoản chi cộng chi phí giao tế. */
export function tripExpenseTotal(data) {
    const costs = TRIP_COST_ITEMS.reduce((sum, item) => sum + tripCostAmount(data.costs, item), 0);
    return costs + tripGuestsTotal(data.guests);
}
/** Số tiền của một phiếu (để hiện cột «Số tiền», in phiếu); `null` = loại phiếu không có tiền. */
export function requestAmount(kind, data) {
    switch (kind) {
        case 'purchase':
            return Math.round(linesTotal(data.lines));
        case 'payment':
            return Math.round(paymentLinesTotal(data.lines));
        case 'trip-expense':
            return Math.round(tripExpenseTotal(data));
        case 'topup':
        case 'advance':
            return Math.round(finite(data.amount));
        default:
            return null;
    }
}
/** «MTN-2026-007». */
export function formatRequestCode(kind, year, sequence) {
    return `${REQUEST_CODE_PREFIX[kind]}-${year}-${String(sequence).padStart(3, '0')}`;
}
//# sourceMappingURL=requests.js.map